<template>
  <div id="page" class="front-layout">
    <sidebar v-show="$store.state.mobileMenu.isShown" id="sidebar" />

    <headbar v-if="!$store.state.mobileMenu.isShown" id="headbar" />

    <router-view v-if="!$store.state.mobileMenu.isShown"
                 class="front-page-content"
    />

    <b-modal :title="errorTitle" ref="errorModal" ok-only centered
             @ok="$router.go(-1)"
    >
      {{ errorMsg }}
    </b-modal>
  </div>
</template>

<script>
import sidebar from '@/components/frontoffice/sidebar'
import headbar from '@/components/frontoffice/header'
import axios from 'axios'

export default {
  components: {
    sidebar,
    headbar
  },

  data () {
    return {
      errorMsg: '',
      errorTitle: 'WebService error'
    }
  },

  created () {
    axios.interceptors.response.use(undefined, (err) => {
      return new Promise(() => {
        if (err.response !== undefined) {
          switch (err.response.status) {
            case 401:
            case 403:
              this.$router.push({path: '/login'})
              break
            case 500:
            case 503:
            default:
              let errorMsg = err.response.data || err.response.status || ''
              let transErrorMsg = `error.${err.response.data}`

              if (this.$te(transErrorMsg)) {
                this.errorMsg = this.$t(transErrorMsg)
              } else {
                this.errorMsg = this.$t('error.500')
                console.error(errorMsg)
              }

              this.$refs.errorModal.show()
              break
          }
          throw err
        }
      })
    })
  },

  methods: {
    translateErrorMessage(message) {
      let errorMsg = 'error.' + message.split(":")[0]

      if (this.$te(errorMsg)) {
        return this.$t(errorMsg)
      } else {
        return message
      }
    }
  }
}
</script>

<style lang="scss">
  .front-layout {
    @import '../../assets/sass/frontoffice/main.scss';
  }
  @import '../../assets/sass/frontoffice/modal.scss';
</style>
